import React from "react";
import {
  Button,
  Flex,
  Text,
  Box,
  useToast,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  CheckboxGroup,
  Checkbox,
  Select,
  Textarea,
  Stack,
} from "@chakra-ui/core";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import useAuth from "../../../context/AuthContext";
import { getUserProfile, updateProfile } from "../../../api/user.service";
import { updateInvestorProfile } from "../../../api/investors.service";

const ProfileEditPage = () => {
  const { state } = useLocation();
  const [profile, setUserProfile] = React.useState(state);
  const history = useHistory();

  // const userSectors =
  //   (profile.investor?.sectors_of_interest &&
  //     JSON.parse(profile.investor?.sectors_of_interest)) ||
  //   [];

  const { register, handleSubmit, errors, formState } = useForm();
  const [expertise, setExpertise] = React.useState([]);
  const [investDuration, setInvestmentDuration] = React.useState([]);
  const [regionInterest, setRegionInterest] = React.useState([]);
  const [capitalType, setCapitalType] = React.useState([]);
  const [currency, setCurrency] = React.useState([]);
  const [withdrawalTime, setWithdrawalTime] = React.useState("");
  const toast = useToast();

  const {
    state: { user },
  } = useAuth();

  const userCurrency =
    profile.investor.currency && JSON.parse(profile.investor.currency);

  const userSectors =
    profile.investor.sectors_of_interest &&
    JSON.parse(profile.investor.sectors_of_interest);

  const onSubmitHandler = async (values) => {
    try {
      const investorFormData = () => {
        if (
          regionInterest.length > 0 ||
          currency.length > 0 ||
          capitalType.length > 0
        ) {
          return {
            sectors_of_interest: expertise,
            region_of_interest: regionInterest,
            capital_type: capitalType,
            currency: currency,
          };
        } else {
          return {
            sectors_of_interest: "",
            region_of_interest: "",
            capital_type: "",
            currency: "",
          };
        }
      };
      const formData = investorFormData();

      const { data } = await updateInvestorProfile({
        ...formData,
        ...values,
      });

      history.push("/dashboard/me");
      toast({
        title: "Profile Update",
        description: "You have successfully updated your profile",
        position: "top",
        duration: 2500,
      });
    } catch (error) {
      console.log(error);
      toast({
        title: "Profile Update",
        description: "Profile update failed. Please try again",
        position: "top",
        duration: 2500,
        status: "error",
      });
    }
  };

  const getDate = (date) => {
    let currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate());
    const parsedDate = currentDate.toISOString().substr(0, 10);

    return parsedDate;
  };

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        data && setUserProfile(data);
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <Box height="100%" w="100%" mt="10">
      <Text fontWeight="700" textAlign="center" fontSize="3xl" my={["2", "8"]}>
        Edit Profile
      </Text>
      <Box w={["95%", "100%"]} shadow="lg" p={["8", "6"]} mx="auto" mt="8">
        <Text
          textAlign="center"
          fontSize={["xl", "3xl"]}
          fontWeight="700"
          fontFamily="Familiar Pro"
          my="4"
        >
          Investor Data Collection form
        </Text>

        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired w="50%">
            <FormLabel htmlFor="company_name" isInvalid={errors.company_name}>
              Company Name*
            </FormLabel>

            <Input
              type="text"
              name="company_name"
              ref={register}
              defaultValue={profile?.investor?.company_name}
            ></Input>
            <FormErrorMessage>
              {errors.company_name && errors.company_name.message}
            </FormErrorMessage>
          </FormControl>
          <Flex direction={["column", "row"]}>
            <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
              <FormLabel
                htmlFor="company_email"
                isInvalid={errors.company_email}
              >
                Email*
              </FormLabel>

              <Input
                type="text"
                name="company_email"
                ref={register}
                defaultValue={profile?.investor?.company_email}
              ></Input>
              <FormErrorMessage>
                {errors.company_email && errors.company_email.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" isInvalid={errors.website_url} flex="1">
              <FormLabel htmlFor="website_url">
                Website.Please enter the link to your organization website if
                any
              </FormLabel>

              <Input
                type="text"
                placeholder=""
                name="website_url"
                ref={register}
                defaultValue={profile.investor?.website_url}
              ></Input>
              <FormErrorMessage>
                {errors.website_url && errors.website_url.message}
              </FormErrorMessage>
            </FormControl>
          </Flex>
          <Flex>
            <FormControl mb="6" isInvalid={errors.year_founded} flex="1">
              <FormLabel htmlFor="year_founded">Year Founded *</FormLabel>

              <Input
                type="text"
                placeholder=""
                name="year_founded"
                ref={register}
                defaultValue={profile.investor?.year_founded}
              ></Input>
              <FormErrorMessage>
                {errors.year_founded && errors.year_founded.message}
              </FormErrorMessage>
            </FormControl>
          </Flex>
          <Flex>
            <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
              <FormLabel
                htmlFor="least_investment_amount"
                isInvalid={errors.least_investment_amount}
              >
                Least Investment Amount *
              </FormLabel>
              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  What is the least you invested in a firm? (Amount in Euro)
                </Text>
              </Box>
              <Input
                type="text"
                placeholder=""
                name="least_investment_amount"
                ref={register({ required: "Field is required" })}
                defaultValue={profile.investor?.least_investment_amount}
              ></Input>
              <FormErrorMessage>
                {errors.least_investment_amount &&
                  errors.least_investment_amount.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl mb="6" mr={["0", "2"]} flex="1" isRequired>
              <FormLabel
                htmlFor="max_investment_amount"
                isInvalid={errors.max_investment_amount}
              >
                Maximum Investment Amount *
              </FormLabel>

              <Box bg="green.50" padding="4" my="2">
                <Text fontSize="14px">
                  What is the maximum you invested in a firm? (Amount in Euro)
                </Text>
              </Box>

              <Input
                type="text"
                placeholder=""
                name="max_investment_amount"
                ref={register({ required: "Field is required" })}
                defaultValue={profile.investor?.max_investment_amount}
              ></Input>
              <FormErrorMessage>
                {errors.max_investment_amount &&
                  errors.max_investment_amount.message}
              </FormErrorMessage>
            </FormControl>
          </Flex>

          <FormControl mb="6" isInvalid={errors.currency} flex="1">
            <FormLabel htmlFor="currency"> Currency Used </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                What currency(ies) do you use when investing?
              </Text>
            </Box>
            <CheckboxGroup
              colorScheme="green"
              spacing="6"
              name="currency"
              defaultValue={userCurrency}
              onChange={(values) => {
                setCurrency(values);
              }}
            >
              <Checkbox value="GHS">GHS</Checkbox>
              <Checkbox value="USD">USD</Checkbox>
              <Checkbox value="EUR">EUR</Checkbox>
              <Checkbox value="GBP">GBP</Checkbox>
              <Checkbox value="Other">Other</Checkbox>
            </CheckboxGroup>

            {currency.map((currency) => {
              return (
                currency === "Other" && (
                  <Input
                    mt="4"
                    type="text"
                    ref={register}
                    placeholder="Other, Specify"
                    name="currency"
                  ></Input>
                )
              );
            })}

            <FormErrorMessage>
              {errors.currency && errors.currency.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb="6" isInvalid={errors.capital_type} flex="1">
            <FormLabel htmlFor="capital_type"> Type of Capital * </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                What type of investments do you usually make into companies
                (equity, loans, grants, mezzanine) (Please tick if applicable)
              </Text>
            </Box>
            <CheckboxGroup
              colorScheme="green"
              spacing="6"
              name="capital_type"
              defaultValue={
                profile.investor?.capital_type && profile.investor?.capital_type
              }
              onChange={(values) => {
                setCapitalType(values);
              }}
            >
              <Checkbox value="Equity">Equity</Checkbox>
              <Checkbox value="Debt">Debt</Checkbox>
              <Checkbox value="Grant">Grant</Checkbox>
              <Checkbox value="Mezzanine">Mezzanine</Checkbox>
              <Checkbox value="Other">Other</Checkbox>
            </CheckboxGroup>

            {capitalType.map((capitalType) => {
              return (
                capitalType === "Other" && (
                  <Input
                    mt="4"
                    type="text"
                    ref={register}
                    placeholder="Other, Specify"
                    name="capital_type"
                  ></Input>
                )
              );
            })}

            <FormErrorMessage>
              {errors.capital_type && errors.capital_type.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb="6" isInvalid={errors.sectors_of_interest} flex="1">
            <FormLabel htmlFor="sectors_of_interest">
              Sectors of Interest
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                Sectors of Interest (Please tick if applicable)
              </Text>
            </Box>
            <CheckboxGroup
              colorScheme="green"
              spacing="6"
              name="sectors_of_interest"
              onChange={(values) => setExpertise(values)}
              defaultValue={userSectors}
            >
              <Checkbox value="Agriculture/Agri-Business">
                Agriculture/Agri-Business
              </Checkbox>
              <Checkbox value="Water, Sanitation and Hygiene (WASH)">
                Water, Sanitation and Hygiene (WASH)
              </Checkbox>
              <Checkbox value="Circular Economy Businesses">
                Circular Economy Businesses
              </Checkbox>
              <Checkbox value="Other">Other</Checkbox>
            </CheckboxGroup>

            {expertise.map((expertise) => {
              return (
                expertise === "Other" && (
                  <Input
                    mt="4"
                    type="text"
                    ref={register}
                    placeholder="Other, Specify"
                    name="sectors_of_interest"
                  ></Input>
                )
              );
            })}
            <FormErrorMessage>
              {errors.sectors_of_interest && errors.sectors_of_interest.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb="6" isInvalid={errors.region_of_interest} flex="1">
            <FormLabel htmlFor="region_of_interest">
              Region of Interest in Ghana*
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">You can select more than one.</Text>
            </Box>
            <CheckboxGroup
              colorScheme="green"
              spacing="6"
              name="region_of_interest"
              onChange={(values) => {
                setRegionInterest(values);
              }}
              defaultValue={
                profile.investor?.region_of_interest &&
                profile.investor?.region_of_interest
              }
            >
              <Checkbox value="Western Region">Western Region</Checkbox>
              <Checkbox value="Ashanti Region">Ashanti Region</Checkbox>
              <Checkbox value="Greater Accra Region">
                Greater Accra Region
              </Checkbox>
            </CheckboxGroup>

            <FormErrorMessage>
              {errors.region_of_interest && errors.region_of_interest.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb="6" isInvalid={errors.female_focused} flex="1">
            <FormLabel htmlFor="female_focused">
              Focus on Female Entrepreneurs *
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                Please does your company prioritize funding for women-led green
                businesses?
              </Text>
            </Box>
            <Select
              colorScheme="green"
              spacing="6"
              name="female_focused"
              ref={register}
              defaultValue={profile.investor?.female_focused}
              // onChange={(values) => setExpertise(values)}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </Select>
            <FormErrorMessage>
              {errors.female_focused && errors.female_focused.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb="6" isInvalid={errors.application_process} flex="1">
            <FormLabel htmlFor="application_process">
              Application Process
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                Please indicate a link to your company's application form or
                provide a brief description of how green business entrepreneurs
                can apply for funding.
              </Text>
            </Box>
            <Textarea
              type="text"
              placeholder=""
              name="application_process"
              ref={register}
              defaultValue={profile.investor?.application_process}
            ></Textarea>
            <FormErrorMessage>
              {errors.application_process && errors.application_process.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl mb="6" isInvalid={errors.deal_closing_time} flex="1">
            <FormLabel htmlFor="deal_closing_time">
              Average Time to Close a Deal
            </FormLabel>

            <Input
              type="text"
              placeholder=""
              name="deal_closing_time"
              ref={register}
              defaultValue={profile.investor?.deal_closing_time}
            ></Input>
            <FormErrorMessage>
              {errors.deal_closing_time && errors.deal_closing_time.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl
            mb="6"
            isInvalid={errors.investment_start_duration}
            flex="1"
          >
            <FormLabel htmlFor="investment_start_duration">
              Investment Start Duration
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                How many weeks does it take to conduct the due diligence and
                start an investment with businesses?
              </Text>
            </Box>
            <Select
              colorScheme="green"
              spacing="6"
              name="investment_start_duration"
              onChange={(e) => {
                setInvestmentDuration(e.target.value);
              }}
              defaultValue={
                profile.investor?.investment_start_duration &&
                profile.investor?.investment_start_duration
              }
            >
              <option value="4 Weeks">4 Weeks</option>
              <option value="8 Weeks">8 Weeks</option>
              <option value="12 Weeks">12 Weeks</option>
              <option value="16 Weeks">16 Weeks</option>
              <option value="Other">Other</option>
            </Select>
            {investDuration === "Other" && (
              <Input
                mt="4"
                type="text"
                ref={register}
                placeholder="Other, Specify"
                name="investment_start_duration"
              ></Input>
            )}

            <FormErrorMessage>
              {errors.investment_start_duration &&
                errors.investment_start_duration.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb="6" isInvalid={errors.return_on_investment} flex="1">
            <FormLabel htmlFor="return_on_investment">
              Average Return on Investment (RoI) sought
            </FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                What's the RoI you aim to realize from an investment? (Please
                enter a number only)
              </Text>
            </Box>
            <Input
              type="number"
              placeholder=""
              name="return_on_investment"
              ref={register}
            ></Input>
            <FormErrorMessage>
              {errors.return_on_investment &&
                errors.return_on_investment.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb="6" isInvalid={errors.withdrawal_time} flex="1">
            <FormLabel htmlFor="withdrawal_time">Withdrawal time.</FormLabel>
            <Box bg="green.50" padding="4" my="2">
              <Text fontSize="14px">
                How long do you aim to stay invested in a start-up company
                before seeking an exit?
              </Text>
            </Box>
            <Select
              colorScheme="green"
              spacing="6"
              name="withdrawal_time"
              ref={register}
              onChange={(e) => setWithdrawalTime(e.target.value)}
            >
              <option value="1 - 3 years">1 - 3 years</option>
              <option value="3 - 6 years">3 - 6 years</option>
              <option value="6 - 10 years">6 - 10 years</option>
              <option value="10+ years">10+ years</option>
              <option value="Other">Other</option>
            </Select>
            {withdrawalTime === "Other" && (
              <Input
                mt="4"
                type="text"
                ref={register}
                placeholder="Other, Specify"
                name="withdrawal_time"
              ></Input>
            )}
            <FormErrorMessage>
              {errors.withdrawal_time && errors.withdrawal_time.message}
            </FormErrorMessage>
          </FormControl>
          <FormControl mb="6" isInvalid={errors.biography} flex="1">
            <FormLabel htmlFor="benefit">Biography</FormLabel>
            <Textarea
              type="text"
              placeholder=""
              name="biography"
              ref={register}
              defaultValue={profile.investor?.biography}
            ></Textarea>
            <FormErrorMessage>
              {errors.biography && errors.biography.message}
            </FormErrorMessage>
          </FormControl>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flex="1"
            w="100%"
          >
            <Button
              type="submit"
              variantColor="green"
              color="white"
              size="md"
              height="48px"
              width={["100%", "200px"]}
              _focus="none"
              my="5"
              isLoading={formState.isSubmitting}
            >
              Update
            </Button>
            <Button
              bg="red.400"
              color="white"
              height="48px"
              width={["100%", "100px"]}
              _focus="none"
              my="5"
              ml="4"
              _hover={{ bg: "red.600" }}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ProfileEditPage;
